<template>
  <section class="app-main content"
           :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}"
  >
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AppMain',
  computed: {
    ...mapState({
      donationsState: state => state.donations.donationsState,
    }),
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped lang="scss">
.app-main {
  min-height: calc(100vh);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #ecf1f8;
  &.loading-overlay {
    &:before {
      content: ' ';

      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.8);
      background-color: red;
      z-index: 100;
    }

    &.loading-overlay-progress:before {
      background: rgba(255, 255, 255, 0.8) url("./logo-spinner.gif") center no-repeat;
      background-size: 150px;
    }
  }
}
.fixed-header+.app-main {
  padding-top: 69px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
